import React from 'react'

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-neutral-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-h3 font-heading text-primary-teal font-semibold">
                CROWBLOCK
              </h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-neutral-700 hover:text-primary-teal transition-colors">
                Home
              </a>
              <a href="/projects" className="text-neutral-700 hover:text-primary-teal transition-colors">
                Projects
              </a>
              <a href="/apps" className="text-neutral-700 hover:text-primary-teal transition-colors">
                Apps
              </a>
              <a href="/about" className="text-primary-teal font-medium">
                About
              </a>
            </nav>
            <div className="flex items-center space-x-4">
              <button className="btn-outline">
                Sign In
              </button>
              <button className="btn-primary">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* About Content */}
      <main className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-h1 font-heading text-neutral-900 mb-6">
              About CROWBLOCK
            </h1>
            <p className="text-l1-r text-neutral-600">
              Empowering communities through transparent crypto crowdfunding
            </p>
          </div>

          <div className="card mb-8">
            <h2 className="text-h2 font-heading text-neutral-900 mb-4">
              Our Mission
            </h2>
            <p className="text-p1-r text-neutral-700 mb-4">
              CROWBLOCK is a revolutionary crypto-powered crowdfunding platform that combines 
              traditional crowdfunding with app discovery features. We enable individuals, 
              communities, and developers to raise funds for blockchain apps, medical relief, 
              emergencies, natural disasters, and innovative projects.
            </p>
            <p className="text-p1-r text-neutral-700">
              Every donation on our platform contributes to a greater cause - we automatically
              deduct a 1.99% commission that goes directly toward global hunger-alleviation efforts,
              making every contribution a force for positive change.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div className="card">
              <h3 className="text-h3 font-heading text-neutral-900 mb-4">
                Fast & Reliable
              </h3>
              <ul className="space-y-2 text-p2-r text-neutral-700">
                <li>• Project review & approval within ≤ 48 hours</li>
                <li>• Withdrawal requests processed ≤ 24 hours</li>
                <li>• Real-time donation tracking</li>
                <li>• Instant transaction verification</li>
              </ul>
            </div>

            <div className="card">
              <h3 className="text-h3 font-heading text-neutral-900 mb-4">
                Transparent & Secure
              </h3>
              <ul className="space-y-2 text-p2-r text-neutral-700">
                <li>• All transactions recorded on-chain</li>
                <li>• Public transparency dashboard</li>
                <li>• Multi-provider authentication</li>
                <li>• Community-driven moderation</li>
              </ul>
            </div>
          </div>

          <div className="card">
            <h2 className="text-h2 font-heading text-neutral-900 mb-4">
              How It Works
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-primary-teal text-white rounded-full flex items-center justify-center mx-auto mb-3 font-semibold">
                  1
                </div>
                <h4 className="text-h4 font-heading text-neutral-900 mb-2">
                  Submit Project
                </h4>
                <p className="text-p3-r text-neutral-600">
                  Create your project or app listing with details, goals, and media
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-primary-teal text-white rounded-full flex items-center justify-center mx-auto mb-3 font-semibold">
                  2
                </div>
                <h4 className="text-h4 font-heading text-neutral-900 mb-2">
                  Get Approved
                </h4>
                <p className="text-p3-r text-neutral-600">
                  Our team reviews and approves quality projects within 48 hours
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-primary-teal text-white rounded-full flex items-center justify-center mx-auto mb-3 font-semibold">
                  3
                </div>
                <h4 className="text-h4 font-heading text-neutral-900 mb-2">
                  Receive Funding
                </h4>
                <p className="text-p3-r text-neutral-600">
                  Community supports your project with Pi donations and engagement
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default AboutPage
